import { createFileRoute, redirect } from "@tanstack/react-router";
import { assert } from "utils";

import { loaderHandler } from "src/lib/loaderHandler";
import { CoachLibraryWorkoutDetailsPage } from "src/pages/CoachLibraryWorkoutDetailsPage";
import { createPersonalLibraryWorkoutsRepository } from "src/repositories/workouts/createPersonalLibraryWorkoutsRepository";
import { exerciseCategoriesQueryOptions } from "src/state/exerciseCategories";
import { exerciseMovementPatternsQueryOptions } from "src/state/exerciseMovementPatterns";
import { exerciseMuscleGroupsQueryOptions } from "src/state/exerciseMuscleGroups";

export const Route = createFileRoute(
  "/_auth/_coach/library/workouts/$workoutId",
)({
  component: CoachLibraryWorkoutDetailsPage,
  async loader({ context, params }) {
    return await loaderHandler(async () => {
      assert(params.workoutId, "No workout ID provided");

      try {
        const workoutsRepository = createPersonalLibraryWorkoutsRepository();
        const [workout] = await Promise.all([
          context.queryClient.query({
            ...workoutsRepository.detailOptions(params.workoutId),
            staleTime: "static",
          }),
          context.queryClient.query({
            ...exerciseCategoriesQueryOptions(),
            staleTime: "static",
          }),
          context.queryClient.query({
            ...exerciseMuscleGroupsQueryOptions(),
            staleTime: "static",
          }),
          context.queryClient.query({
            ...exerciseMovementPatternsQueryOptions(),
            staleTime: "static",
          }),
        ]);

        return {
          data: {
            workout,
          },
          breadcrumb: {
            label: workout.name,
            href: `/workouts/${workout.id}`,
            id: workout.id,
          },
        };
      } catch {
        throw redirect({ to: "/library/workouts" });
      }
    });
  },
});
